'use strict';

/* =====================================================
   ONI SITES — MAIN SCRIPT (optimised)
   ===================================================== */

function initLoader() {}
function initPageTransitions() {}

/* ─── NAVIGATION ─────────────────────────────── */
function initNav() {
  const nav = document.querySelector('.nav');
  const hamburger = document.querySelector('.nav-hamburger');
  const mobileMenu = document.querySelector('.nav-mobile');
  if (!nav) return;

  // Single scroll handler for shadow — throttled via passive
  let navScrollScheduled = false;
  window.addEventListener('scroll', () => {
    if (navScrollScheduled) return;
    navScrollScheduled = true;
    requestAnimationFrame(() => {
      nav.style.boxShadow = window.scrollY > 20
        ? '0 8px 40px rgba(15,14,13,0.12),0 1px 0 rgba(255,255,255,0.8) inset'
        : '0 4px 24px rgba(15,14,13,0.08),0 1px 0 rgba(255,255,255,0.8) inset';
      navScrollScheduled = false;
    });
  }, { passive: true });

  // Dark nav
  const darkSections = document.querySelectorAll('.section-dark,.section-ink,.dark-nav-trigger');
  if (darkSections.length) {
    const navObs = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.intersectionRatio > 0.3) {
          nav.classList.add('dark-bg');
        } else {
          const any = [...darkSections].some(el => {
            const r = el.getBoundingClientRect();
            return r.top < 60 && r.bottom > 60;
          });
          if (!any) nav.classList.remove('dark-bg');
        }
      });
    }, { threshold: 0.3, rootMargin: '-50px 0px 0px 0px' });
    darkSections.forEach(s => navObs.observe(s));
  }

  // Hamburger
  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', () => {
      const isOpen = hamburger.classList.toggle('open');
      if (isOpen) {
        mobileMenu.classList.add('open');
        mobileMenu.style.cssText = 'display:flex;opacity:0;transform:translateY(-8px)';
        requestAnimationFrame(() => {
          mobileMenu.style.opacity = '1';
          mobileMenu.style.transform = 'translateY(0)';
        });
      } else {
        mobileMenu.style.opacity = '0';
        mobileMenu.style.transform = 'translateY(-8px)';
        setTimeout(() => {
          if (!hamburger.classList.contains('open')) {
            mobileMenu.style.display = 'none';
            mobileMenu.classList.remove('open');
          }
        }, 300);
      }
    });
    mobileMenu.querySelectorAll('a').forEach(link => {
      link.addEventListener('click', () => {
        hamburger.classList.remove('open');
        mobileMenu.style.opacity = '0';
        mobileMenu.style.transform = 'translateY(-8px)';
        setTimeout(() => {
          mobileMenu.style.display = 'none';
          mobileMenu.classList.remove('open');
        }, 300);
      });
    });
  }

  // Current page fallback (Liquid already renders this; JS covers alternate/trailing URLs).
  const normalisePath = value => {
    const path = new URL(value, location.origin).pathname.replace(/\/+$/, '');
    return path || '/';
  };
  const currentPath = normalisePath(location.href);
  document.querySelectorAll('.nav-page-link').forEach(link => {
    if (normalisePath(link.href) === currentPath) {
      link.classList.add('active');
      link.setAttribute('aria-current', 'page');
    }
  });
}

/* ─── CARD TILT (hero preview only) ─────────────── */
function initCardTilt() {
  if (window.matchMedia('(pointer: coarse)').matches) return;
  document.querySelectorAll('.preview-card-main').forEach(card => {
    card.addEventListener('mousemove', e => {
      const r = card.getBoundingClientRect();
      const rx = (e.clientY - r.top  - r.height / 2) / r.height * 10;
      const ry = (e.clientX - r.left - r.width  / 2) / r.width  * -10;
      card.style.transform = `translate(-50%,-50%) perspective(800px) rotateX(${rx}deg) rotateY(${ry}deg) scale(1.02)`;
    });
    card.addEventListener('mouseleave', () => { card.style.transform = ''; });
  });
}

/* ─── PLANS TOGGLE ───────────────────────────────── */
function initPlansToggle() {
  const btns = document.querySelectorAll('.plans-toggle-btn');
  if (!btns.length) return;
  btns.forEach(btn => {
    btn.addEventListener('click', () => {
      btns.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      document.body.classList.toggle('view-onetime', btn.dataset.view === 'onetime');
    });
  });
}

/* ─── FAQ ACCORDION ──────────────────────────────── */
function initFAQ() {
  const items = document.querySelectorAll('.faq-item');
  items.forEach(item => {
    const q = item.querySelector('.faq-question');
    if (!q) return;
    q.addEventListener('click', () => {
      const wasOpen = item.classList.contains('open');
      items.forEach(i => i.classList.remove('open'));
      if (!wasOpen) item.classList.add('open');
    });
  });
}

/* ─── MODAL ──────────────────────────────────────── */
function initModal() {
  document.querySelectorAll('.modal-overlay').forEach(overlay => {
    overlay.addEventListener('click', e => { if (e.target === overlay) closeModal(overlay); });
    const closeBtn = overlay.querySelector('.modal-close');
    if (closeBtn) closeBtn.addEventListener('click', () => closeModal(overlay));
  });
  document.querySelectorAll('[data-modal]').forEach(trigger => {
    trigger.addEventListener('click', e => {
      e.preventDefault();
      const modal = document.getElementById(trigger.dataset.modal);
      if (modal) openModal(modal);
    });
  });
}
function openModal(o)  { o.classList.add('open');    document.body.style.overflow = 'hidden'; }
function closeModal(o) { o.classList.remove('open'); document.body.style.overflow = '';       }

/* ─── SCROLL INDICATOR ───────────────────────────── */
function initScrollIndicator() {
  const el = document.querySelector('.scroll-indicator');
  if (!el) return;
  let done = false;
  window.addEventListener('scroll', () => {
    if (done || window.scrollY <= 100) return;
    done = true;
    el.style.opacity = '0';
    el.style.pointerEvents = 'none';
  }, { passive: true });
}

/* ─── HOVER GLOWS ────────────────────────────────── */
function initHoverGlows() {
  document.querySelectorAll('.plan-card,.work-thumb,.offer-card').forEach(el => {
    el.addEventListener('mousemove', e => {
      const r = el.getBoundingClientRect();
      el.style.setProperty('--glow-x', (e.clientX - r.left) + 'px');
      el.style.setProperty('--glow-y', (e.clientY - r.top)  + 'px');
    });
  });
}

/* ─── SMOOTH ANCHOR SCROLL ───────────────────────── */
function initAnchorScroll() {
  document.querySelectorAll('a[href^="#"]').forEach(link => {
    link.addEventListener('click', e => {
      const target = document.getElementById(link.getAttribute('href').slice(1));
      if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth' }); }
    });
  });
}

/* ─── FORM SUBMISSION ────────────────────────────── */
function initForms() {
  document.querySelectorAll('form').forEach(form => {
    form.addEventListener('submit', e => {
      e.preventDefault();
      const btn = form.querySelector('.form-submit-btn');
      if (!btn) return;
      const orig = btn.innerHTML;
      btn.innerHTML = '✓ Sent! We\'ll be in touch.';
      btn.style.background = '#4a6800';
      setTimeout(() => { btn.innerHTML = orig; btn.style.background = ''; form.reset(); }, 4000);
    });
  });
}

/* ─── INIT ───────────────────────────────────────── */
document.addEventListener('DOMContentLoaded', () => {
  initNav();
  initCardTilt();
  initPlansToggle();
  initFAQ();
  initModal();
  initScrollIndicator();
  initHoverGlows();
  initAnchorScroll();
  initForms();
});


// Process comparison heading alignment fallback.
(function(){
  function fixProcessComparisonHeading(){
    var title=document.querySelector('.proc-compare-head-left .proc-compare-title');
    if(title){ title.textContent='Send us the basics.'; }
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',fixProcessComparisonHeading,{once:true});
  else fixProcessComparisonHeading();
  window.addEventListener('pageshow',fixProcessComparisonHeading);
})();
